export default "__VITE_PUBLIC_ASSET__935bf56f__"